import { TextAlignment, TitleSize } from "@/constants/content";
import { SiteBuilderModuleTextFieldType } from "@/constants/site-builder";
import { ColorVariant, FontVariant } from "@/constants/theme";
import { createThemeColorObject } from "@/utils/theme/createThemeColorObject";
import type {
  SiteBuilderModuleHeaderField,
  SiteBuilderModuleTextField,
} from "@/types/site-builder";

export function createBasicHeaderFieldObject(
  text?: string,
  tag = TitleSize.H2,
  alignment = TextAlignment.Left,
): SiteBuilderModuleHeaderField {
  return {
    type: SiteBuilderModuleTextFieldType.Header,
    text,
    tag,
    alignment,
    fontVariant: FontVariant.Default,
    color: createThemeColorObject(ColorVariant.Inherit),
  };
}

export function createBasicTextFieldObject(
  text?: string,
  alignment = TextAlignment.Left,
  color = ColorVariant.Inherit,
): SiteBuilderModuleTextField {
  return {
    type: SiteBuilderModuleTextFieldType.Text,
    text,
    alignment,
    fontVariant: FontVariant.Default,
    color: createThemeColorObject(color),
  };
}
